import React, { createContext, useState, useContext } from "react";

const SidebarContext = createContext();
const SelectedCategorySidebarContext = createContext();

export const useSidebar = () => {
    return useContext(SidebarContext);
};

export const useSelectedCategorySidebar = () => {
    return useContext(SelectedCategorySidebarContext);
};

export default function SidebarProvider({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [selectedCategorySidebar, setSelectedCategorySidebar] = useState({
        id: -1,
        categoryName: "الرئيسية",
    });

    const toggleSidebar = () => {
        // document.body.style.overflow = sidebarOpen ? "unset" : "hidden sm:unset";
        setSidebarOpen((prev) => !prev);
    };

    return (
        <SidebarContext.Provider value={{ sidebarOpen, toggleSidebar }}>
            <SelectedCategorySidebarContext.Provider
                value={{ selectedCategorySidebar, setSelectedCategorySidebar }}
            >
                {children}
            </SelectedCategorySidebarContext.Provider>
        </SidebarContext.Provider>
    );
}
